<template>
    <v-app-bar
        class="admin-app-bar elevation-0"
        app
    >
        <v-icon @click.stop="eventBus.$emit('admin-toggle-drawer')">far fa-bars</v-icon>

        <h4 v-if="pageTitle" class="ml-4">{{ pageTitle }}</h4>

        <v-spacer />

        <!-- <v-tooltip bottom>
            <template v-slot:activator="{ on }">
                <v-btn
                    icon
                    color="primary"
                    v-on="on"
                    @click="$tours['appTour'].start()"
                >
                    <v-icon>fal fa-question-circle</v-icon>
                </v-btn>
            </template>
            <span>{{ $t('tour.guide') }}</span>
        </v-tooltip> -->

        <v-btn
            v-if="allowKitchen"
            color="primary"
            text
            @click="$router.push({ name: 'kitchen', query: { from: 'adminDashboard' } }).catch(err => {})"
        >
            <v-icon class="mr-3">fal fa-clipboard-list</v-icon>
            {{ $t('general.kitchen') }}
        </v-btn>

        <v-btn
            v-if="isAllegra && !disableSales"
            color="primary"
            text
            @click="$router.push({ name: 'allegraOrder' }).catch(err => {})"
        >
            <v-icon class="mr-3">fal fa-share-all</v-icon>
            {{ $t('general.sell_items') }}
        </v-btn>

        <v-btn
            v-else-if="!isAllegra && !disableSales && allows('nav_access_tables')"
            color="primary"
            text
            @click="$router.push({ name: 'tables' }).catch(err => {})"
        >
            <v-icon class="mr-3">fal fa-share-all</v-icon>
            {{ $t('general.table_plan') }}
        </v-btn>

        <v-btn
            v-else-if="!isAllegra && !disableSales && allows('nav_access_order') && curShift"
            color="primary"
            text
            @click="$router.push({ name: 'order' }).catch(err => {})"
        >
            <v-icon class="mr-3">fal fa-share-all</v-icon>
            {{ $tc('general.fast_order', 1) }}
        </v-btn>

        <v-menu bottom transition="slide-y-transition">
            <template v-slot:activator="{ on }">
                <v-btn color="primary" class="mr-1" v-on="on" icon>
                    <v-avatar size="44">
                        <v-icon>fal fa-user-circle</v-icon>
                    </v-avatar>
                </v-btn>
            </template>

            <v-list v-if="user" class="user-menu">
                <v-list-item :key="1" class="label">
                    <v-list-item-avatar>
                        <v-avatar class="primary" size="40">
                            <v-icon dark>fal fa-user</v-icon>
                        </v-avatar>
                    </v-list-item-avatar>

                    <v-list-item-content>
                        <v-list-item-title>{{ user.name }}</v-list-item-title>
                        <v-list-item-subtitle>{{ translateUserRole(user.role) }}</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>

                <v-divider />

                <v-list-item
                    :key="2"
                    @click="
                        $router.push({ name: 'adminAccount' }).catch(err => {});
                        pageTitle = $t('general.account');
                    "
                >
                    <v-list-item-action class="minw30">
                        <v-icon>fal fa-user-cog</v-icon>
                    </v-list-item-action>

                    <v-list-item-content>
                        <v-list-item-title>{{ $t('general.my_account') }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <v-divider />

                <v-list-item :key="3" @click="logout">
                    <v-list-item-action>
                        <v-icon class="minw30">fal fa-sign-out</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>{{ $t('general.log_out') }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
        </v-menu>
    </v-app-bar>
</template>

<script>
import { mapGetters } from 'vuex';
import UserService from '@/services/UserService';
import Shift from '@/models/Shift';
import Terminal from '@/models/Terminal';

export default {
    created() {
        this.eventBus.$on('route-update', this.onRouteUpdate);
    },

    beforeDestroy() {
        this.eventBus.$off('route-update', this.onRouteUpdate);
    },

    data() {
        return {
            pageTitle: null
        };
    },

    computed: {
        ...mapGetters(['impersonate', 'modules']),

        curShift() {
            return Shift.current();
        },

        singleCashRegister() {
            return this.tenant && this.tenant.venue && !!this.tenant.venue.settings.cash_register.single
        },

        disableSales() {
            const enableSales = AppStorage.local().getItem('enable-web-sales') === 'true'
            if(enableSales) {
                return false
            }

            return !this.singleCashRegister && !this.impersonate && this.device.platform === 'web' && process.env.VUE_APP_ENV === 'production'
        },

        allowKitchen() {
            if(isAllegra) return false

            const kdsRegistered = Terminal.all().some(t => t.isKitchenDisplaySystem())
            return this.modules.kds && kdsRegistered && this.allows('access_terminals')
        }
    },

    methods: {
        onRouteUpdate(route) {
            this.pageTitle = route.title
        },

        translateUserRole(role) {
            // if default role and name translation exists use it
            const transKey = `user_roles.default.${role.name}`
            if(this.$t(transKey) !== transKey && role.id <= 4) {
                return this.$t(transKey)
            }

            return role.name
        },

        logout() {
            UserService.logout();
            this.$router.push({ name: 'userLogin' }).catch(err => {});
        }
    }
};
</script>

<style scoped lang="scss">
.admin-app-bar {
    border-bottom: 1px solid #d6d8e4;

    .user-menu {
        padding: 0;
        font-size: 16px;

        .label {
            background: #f0f0f0;
        }
    }
}
</style>
